import { Field } from 'formik'
import { TextField } from 'formik-mui'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

import { AuthDirectRequestVerificationCodeQuery } from '@cibo/core'
import { Form, SubmitButton } from '@cibo/ui'
import { Button, FormHelperText, InputLabel, Stack, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'
import { AUTH_ROUTES } from '../../pages/consts'

type Props = {
  error: any
  formAuthCode?: string
  formAuthToken?: string
  loading?: boolean
  onSubmit(values: Pick<AuthDirectRequestVerificationCodeQuery, 'username'>): void
}

export const RequestCodeForm = ({ error, loading, onSubmit }: Props) => {
  const { t } = useTranslation('auth')
  const validationSchema = Yup.object().shape({
    username: Yup.string().email(t('emailErrorInvalid')).required(t('emailErrorRequired')),
  })

  const catastrophicError = error && error.httpCode >= 500 && error.httpCode < 600

  return (
    <Form initialValues={{ username: '' }} onSubmit={onSubmit} validationSchema={validationSchema}>
      <Stack spacing={4}>
        <Stack spacing={2}>
          <Typography variant="h5">{t('forgotPasswordHeader')}</Typography>
          <Typography>{t('forgotPasswordDescription')}</Typography>
        </Stack>

        <Stack spacing={2}>
          <Stack>
            <InputLabel shrink htmlFor="email">
              {t('email')}
            </InputLabel>
            <Field
              autoFocus
              id="email"
              name="username"
              type="email"
              component={TextField}
              disabled={loading}
            />
          </Stack>

          {error && error.status === 404 && (
            <FormHelperText error>{t('emailNotFound')}</FormHelperText>
          )}
          {catastrophicError && (
            <FormHelperText error>{t('forgotPassword500Error')}</FormHelperText>
          )}

          <SubmitButton
            disabled={catastrophicError}
            title={t('sendCode')}
            loading={loading}
            testId="submitBtn"
          />
          <Button component={NavLink} to={AUTH_ROUTES.LOGIN}>
            {t('cancel')}
          </Button>
        </Stack>
      </Stack>
    </Form>
  )
}
